import { TableCell, TableRow } from '@mui/material'
import type { GeneralDataProps } from './types'

export const GeneralData = (props: GeneralDataProps) => {
  const { data } = props
  const rows = [
    {
      label: 'Полное наименование',
      value: data?.title ?? '',
    },
    {
      label: 'Сокращённое наименование',
      value: data?.short_title ?? '',
    },
    {
      label: 'ИНН',
      value: data?.inn ?? '',
    },
    {
      label: 'КПП',
      value: data?.kpp ?? '',
    },
    {
      label: 'ОГРН',
      value: data?.ogrn ?? '',
    },
  ]

  return (
    <>
      {rows.map((item, index) => (
        <TableRow key={index}>
          <TableCell width={'30%'}>{item.label}</TableCell>
          <TableCell>{item.value}</TableCell>
        </TableRow>
      ))}
    </>
  )
}
